const setAttributes = (script, attrs) => {
  Object.keys(attrs).forEach((attr) => {
    script.setAttribute(attr, attrs[attr])
  })
}

const stdOnEnd = (script, cb) => {
  script.onload = () => {
    cb(null, script)
  }
  script.onerror = () => {
    cb(new Error(`Failed to load ${this.src}`), script)
  }
}

/* IE 9 and below */
const ieOnEnd = (script, cb) => {
  script.onreadystatechange = function() {
    if (this.readyState !== 'complete' && this.readyState !== 'loaded') return
    this.onreadystatechange = null
    cb(null, script)
  }
}

const loadScript = (src, opts, cb = () => {}) => {
  if (typeof window === 'undefined') return
  const head = document.head || document.getElementsByTagName('head')[0]
  const script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }
  opts = opts || {}
  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8'
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = opts.text
  }

  const onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)
  if (!script.onload) {
    stdOnEnd(script, cb)
  }

  head.appendChild(script)
}

export default loadScript
